module.exports = __webpack_public_path__ + "static/img/pro5.3427286.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/base/pro5.png
// module id = 1650
// module chunks = 2